// @flow

import type {MarkdocFragmentRegistration} from 'docs/markdoc';
import {Tag} from 'docs/util';

const ICONS = [
  'customer',
  'platform',
  'account',
  'stripe',
  'terminal',
  'location',
  'pos',
  'bank',
  'client',
  'server',
  'finaccount',
];

export const Node: MarkdocFragmentRegistration = {
  tag: 'node',
  attributes: {
    state: {
      type: String,
      matches: ['success', 'warning', 'error', 'canceled'],
      description:
        'Used only for state diagrams. Adds a background color and icon to the node alongside the text passed as children.',
    },
    icon: {
      type: String,
      matches: ICONS,
      description:
        'Used only in overview diagrams. Renders an icon as the node with corresponding label.',
    },
    x: {
      type: Number,
      description:
        'Positions the node at the x-coordinate on the diagram. If you want to manually position the node you must provide both an x and a y value.',
      default: 0,
    },
    y: {
      type: Number,
      description:
        'Positions the node at the y-coordinate on the diagram. If you want to manually position the node you must provide both an x and a y value.',
      default: 0,
    },
  },
  validate(node) {
    const errors = [];
    const {id, x, y} = node.attributes;
    if (!id) {
      errors.push({
        id: 'missing-id',
        level: 'critical',
        message: 'Each {% node %} tag in a diagram requires a unique id.',
      });
    }
    if ((x && !y) || (!x && y)) {
      errors.push({
        id: 'missing-position',
        level: 'critical',
        message:
          'Provide both an x and a y coordinate to manually position a node. Remove both the x and y attributes to have the diagram automatically position the node for you.',
      });
    }
    return errors;
  },
  render(node, config) {
    const attributes = node.renderAttributes(this.attributes, config);
    const children = node.renderChildren(config);

    return new Tag('node', attributes, children);
  },
};
